/**
 * Amazon-Style Warenkorb-Badge für Rimaal.de (Impulse-Theme)
 * ------------------------------------------------------------
 * Zeigt im Header-Warenkorb-Icon (snippets/header-icons.liquid,
 * [data-cart-count-badge]) die aktuelle Artikelanzahl an und aktualisiert
 * sie automatisch, sobald sich der Warenkorb ändert.
 *
 * Funktionsweise: `window.fetch` wird einmalig mit einem dünnen Wrapper
 * versehen, der jeden Request an einen Shopify-Cart-Endpunkt
 * (/cart/add.js, /cart/change.js, /cart/update.js, /cart/clear.js)
 * erkennt und danach den aktuellen Stand per /cart.js nachlädt. Dadurch
 * funktioniert die Badge-Aktualisierung automatisch für JEDEN Weg, wie
 * Artikel hinzugefügt/geändert werden – das bestehende Quick-Add-Script
 * (snippets/product-grid-item.liquid), den normalen "In den Warenkorb"-
 * Button auf der Produktseite, die Mengen-Stepper im Cart-Drawer/auf der
 * Cart-Seite sowie den "Entfernen"-Link – ohne dass diese Stellen etwas
 * von dieser Datei wissen müssen.
 *
 * Öffentliche API für eigene Erweiterungen:
 *   window.cartBadge.set(count)   – Badge direkt auf einen Wert setzen
 *   window.cartBadge.refresh()    – Aktuellen Stand per /cart.js nachladen
 */
(function () {
  'use strict';

  var BADGE_SELECTOR = '[data-cart-count-badge]';
  var A11Y_SELECTOR = '[data-cart-count-accessible]';
  var VISIBLE_CLASS = 'cart-count-badge--visible';
  var BOUNCE_CLASS = 'cart-count-badge--bounce';
  // Größen-Abstufungen je nach Ziffernanzahl, damit auch drei-/vierstellige
  // (und mehr) Zahlen sauber ins Badge passen, statt bei "99+" gekappt zu
  // werden. Siehe cart-badge.css für die zugehörigen Font-Size-/Padding-Regeln.
  var DIGIT_CLASSES = ['cart-count-badge--lg', 'cart-count-badge--xl'];
  // Erfasst /cart/add.js, /cart/add, /cart/change.js, /cart/update.js, /cart/clear.js
  // – jeweils mit oder ohne Query-String, relativ oder absolut.
  var CART_WRITE_PATTERN = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  function getBadgeEl() {
    return document.querySelector(BADGE_SELECTOR);
  }

  // Kein "99+"-Limit mehr: Es wird immer die exakte, vollständige
  // Artikelanzahl ausgegeben (z. B. "105", "250", "1420").
  function formatCount(count) {
    return String(count);
  }

  // Ab drei bzw. vier Ziffern eine passende Modifier-Klasse für kleinere
  // Schrift/engeres Padding zurückgeben (siehe cart-badge.css), damit lange
  // Zahlen nicht umbrechen oder über das Icon hinauslaufen.
  function digitSizeClass(count) {
    var digits = String(count).length;
    if (digits >= 4) return 'cart-count-badge--xl';
    if (digits === 3) return 'cart-count-badge--lg';
    return null;
  }

  function setCount(count, options) {
    options = options || {};
    var badge = getBadgeEl();
    if (!badge) return;

    var previous = parseInt(badge.getAttribute('data-count') || badge.textContent, 10);
    if (isNaN(previous)) previous = 0;

    badge.textContent = formatCount(count);
    badge.setAttribute('data-count', count);
    badge.classList.remove.apply(badge.classList, DIGIT_CLASSES);
    var sizeClass = digitSizeClass(count);
    if (sizeClass) badge.classList.add(sizeClass);
    badge.classList.toggle(VISIBLE_CLASS, count > 0);

    var a11y = document.querySelector(A11Y_SELECTOR);
    if (a11y) {
      a11y.textContent =
        count + ' ' + (count === 1 ? 'Artikel' : 'Artikel') + ' im Warenkorb';
    }

    if (options.animate !== false && count > previous) {
      bounce(badge);
    }
  }

  function bounce(badge) {
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) return;

    badge.classList.remove(BOUNCE_CLASS);
    void badge.offsetWidth; // Reflow erzwingen, damit die Animation neu startet
    badge.classList.add(BOUNCE_CLASS);
    badge.addEventListener('animationend', function handler() {
      badge.classList.remove(BOUNCE_CLASS);
      badge.removeEventListener('animationend', handler);
    });
  }

  function refresh(options) {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        setCount(cart.item_count, options);
        return cart;
      })
      .catch(function () {});
  }

  function patchFetch() {
    if (window.__cartBadgeFetchPatched || typeof window.fetch !== 'function') return;
    window.__cartBadgeFetchPatched = true;

    var originalFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isCartWrite = CART_WRITE_PATTERN.test(url);
      var result = originalFetch.apply(this, arguments);

      if (isCartWrite) {
        result
          .then(function (response) {
            if (response && response.ok) refresh();
            return response;
          })
          .catch(function () {});
      }

      return result;
    };
  }

  document.addEventListener('DOMContentLoaded', function () {
    patchFetch();
    // Initialer Abgleich beim Laden (z. B. nach Zurück-Navigation aus dem
    // Bounce-Cache) – ohne Bounce-Effekt, da sich hier nichts "erhöht" hat.
    refresh({ animate: false });
  });

  window.cartBadge = { set: setCount, refresh: refresh };
})();
